import { useContext, useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { GET_COUNTRIES } from '../../graphql/queries';
import { TextsContext } from '../../context/textsContext';
import { capitalizeEveryWord } from '../../utils/Generics';
import CountriesChildrenOnly from '../../utils/CountriesChildrenOnly.json';

/**
 * Loads the list of countries (reusing the quoter GET_COUNTRIES query) and maps it
 * to the { value, label } shape consumed by DropdownComponent.
 *
 * Debe ofrecer exactamente los mismos países que el campo "Country of residence" de
 * Step1 (`Step1Pages`) y del form de templates (`BaseInformationStep`): esos filtran
 * `CountriesChildrenOnly` (países que sólo pueden ser país de un dependiente, nunca de
 * residencia), así que un plan guardado nunca los tendrá y como opción de filtro serían
 * inservibles. Se replica ese mismo filtro aquí para que ambas listas coincidan.
 */
export const useCountryOptions = () => {
    const { getCurrentLanguage } = useContext(TextsContext);
    const language = getCurrentLanguage();

    const { data, loading } = useQuery(GET_COUNTRIES, {
        variables: { language, skip: 0, take: 300 },
    });

    const options = useMemo(() => {
        const countries = data?.countries ?? [];
        return countries
            .filter((country) => !CountriesChildrenOnly.includes(country.isoNum))
            .map((country) => ({
                value: country.isoNum,
                label: capitalizeEveryWord(country.description),
            }))
            .sort((a, b) => a.label.localeCompare(b.label));
    }, [data]);

    return { options, loading };
};

export default useCountryOptions;
